import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss']
})
export class SkeletonComponent implements OnInit {
  @Input() section: string;
  @Input() loop: number[];
  constructor() { }

  ngOnInit(): void {
    this.loop = Array.from(Array(this.loop).keys());
  }

}
